"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
function getContainer(container, defaultContainer) {
    container = typeof container === 'function' ? container() : container;
    return container && ReactDOM.findDOMNode(container) || defaultContainer;
}
exports.getContainer = getContainer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-overlays/utils/get-container.js
// module id = 127
// module chunks = 0 1 2 3 4 5 6